import { Box, Button, Popover, Typography } from '@mui/material';
import React from 'react';
import { BuyMeACoffeeButton } from './buy-me-a-coffee';
import { RevolutDonationQR } from './revolut-donation-qr';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { red } from '@mui/material/colors';

export const SupportUsButton = () => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const popoverContentStyles = {
        padding: '16px',
        minHeight: '120px',
        minWidth: '200px',
        maxWidth: '300px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-evenly'
    };

    const supportUsStyles = {
        borderRadius: '20px',
        fontWeight: 'bold'
    };

    return (
        <Box sx={{ margin: '5px 15px 0 15px' }}>
            <Button
                variant="contained"
                color="primary"
                sx={(theme) => ({ ...supportUsStyles, backgroundColor: theme.palette.listColor.main })}
                onClick={handleClick}
                className="support-us-button"
            >
                <span style={{paddingRight: '8px'}}>Support Us</span> <VolunteerActivismIcon sx={{ color: red[500] }} />
            </Button>
            <Popover
                id="support-us-popover"
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                {/* Support / Donation buttons */}
                <Box sx={popoverContentStyles}>
                    <Typography variant="h6">Support Us</Typography>
                    <Typography variant="body1" sx={{textAlign: 'center'}}>
                        Keeping this app online costs money. 
                        <br />
                        Please support us to keep this app alive and motivate further developments.</Typography>
                    <BuyMeACoffeeButton />
                    <RevolutDonationQR />
                </Box>
            </Popover>
        </Box>
    );
};
